<template>
  <div>
    <div
        class="text-center mt-16"
        v-if="dataFetching"
    >
      <v-progress-circular
          indeterminate
          color="primary"
      ></v-progress-circular>
    </div>
    <v-alert
        color="grey"
        text
        v-if="purchasables.length === 0 && dataFetching === false"
    >No purchasable record found
    </v-alert>

    <PaginatedList
        v-if="purchasables.length > 0"
        :items="purchasables"
        :itemsPerPage="5"
        :pageChangeCallback="paginatedListPageChangeCallback"
    >
      <template v-slot:content="{items}">
        <div
          v-for="(purchasable, index) in items"
          :key="index"
        >
          <v-card class="mb-4">
            <v-card-text>
              <div class="d-flex justify-space-between align-center mb-4">
                <h3>{{ purchasable.name === '' ? '-' : purchasable.name }}</h3>

                <slot name="topRightBtn" v-bind="purchasable"></slot>
              </div>
              <div>
                <p class="text-14 font-weight-medium grey--text text--darken-2 mb-0">Description: </p>
                <p class="text-14 font-weight-medium grey--text text--darken-1">
                  {{ purchasable.description === '' ? '-' : purchasable.description }}
                </p>
              </div>

              <div class="d-flex align-center flex-wrap">
                <div class="flex-1 mr-3">
                  <h6 class="grey--text">
                    Purchasable Id
                  </h6>
                  <h4 class="font-600">
                    {{ purchasable.purchasableId }}
                  </h4>
                </div>

                <div class="flex-1 mr-3">
                  <h6 class="grey--text">
                    Sold Amount
                  </h6>
                  <h4 class="font-600">
                    {{ purchasable.soldPurchasableNum }} / {{ purchasable.maxSupply }}
                  </h4>
                </div>

                <div class="flex-1 mr-3">
                  <h6 class="grey--text">Price</h6>
                  <h4 class="font-weight-medium">${{ parseFloat(purchasable.price) / 10 ** paymentTokenDecimal }}</h4>
                </div>

                <div class="flex-1">
                  <h6 class="grey--text">Nft</h6>
                  <v-icon
                      @click.native="viewNftMetadataHandle(purchasable)"
                      class="cursor-pointer"
                      color="indigo lighten-3"
                      size="28"
                  >mdi-image-search
                  </v-icon>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </template>
    </PaginatedList>

    <NftMetadataDialog
        v-if="nft"
        :nft="nft"
        :onCloseDialogHandle="completeViewNftMetadataHandle"
    ></NftMetadataDialog>
  </div>
</template>

<script>
import config from "@/config";
import PaginatedList from "@/components/PaginatedList";
import backendCall from "@/lib/backendCall";
import NftMetadataDialog from "@/components/PurchasableList/NftMetadataDialog";
import store from "@/store";
import Vue from "vue";

export default {
  name: "PurchasableList",
  components: {
    NftMetadataDialog,
    PaginatedList
  },
  mounted() {
    this.fetchPurchasablePageData()
  },
  props: {
    storeAccount: String
  },
  computed: {
    paymentTokenDecimal() {
      return config.commonConfig.paymentCoinDecimal
    }
  },
  data(){
    return {
      purchasables: [],
      nftContract: '',
      nft: null,
      dataFetching: false
    }
  },
  methods: {
    async fetchPurchasablePageData() {
      try {
        this.dataFetching = true
        const getPurchasablePageDataRes = await backendCall.purchasable.getPurchasablePageData(this.storeAccount)
        if (getPurchasablePageDataRes.status === 1) {
          // if no purchasable data found
          if (!getPurchasablePageDataRes.data || !getPurchasablePageDataRes.data.purchasable) {
            this.purchasables = []
            return
          }

          this.nftContract = getPurchasablePageDataRes.data.nftContract

          this.purchasables = getPurchasablePageDataRes.data.purchasable
          // let purchasables = this.purchasables
          // //get purchasable info
          // let promiseArray = []
          //
          // for (let i = 0; i < purchasables.length; i++) {
          //   promiseArray.push(backendCall.purchasable.getPurchasableInfo(this.storeAccount, purchasables[i].purchasableId))
          // }
          //
          // const promiseArrayRes = await Promise.all(promiseArray)
          // for (let i = 0; i < promiseArrayRes.length; i++) {
          //   purchasables[i].name = (promiseArrayRes[i].status === 1 && promiseArrayRes[i].data) ? promiseArrayRes[i].data.name : ''
          //   purchasables[i].description = (promiseArrayRes[i].status === 1 && promiseArrayRes[i].data) ? promiseArrayRes[i].data.description : ''
          //   purchasables[i].imageUrl = (promiseArrayRes[i].status === 1 && promiseArrayRes[i].data) ? promiseArrayRes[i].data.imageUrl : ''
          //   this.$set(this.purchasables, i, purchasables[i])
          // }
        }
      } catch (e) {
        console.error(e)
        Vue.notify({
          type: "error",
          text: e.message
        })
      } finally {
        this.dataFetching = false
      }
    },
    async viewNftMetadataHandle(purchasable) {
      try {
        store.state.pageLoading = true
        const res = await backendCall.nft.getNftMetadata(this.nftContract, purchasable.tokenId)
        if (res.status === 1) {
          this.nft = res.data
        } else if (res.status === 0) {
          throw Error(res.message)
        }
      }catch (e) {
        console.error(e)
      }finally {
        store.state.pageLoading = false
      }
    },
    async completeViewNftMetadataHandle() {
      this.nft = null
    },
    paginatedListPageChangeCallback(items, page, itemsPerPage) {
      for (let i=((page-1) * itemsPerPage); i<page*itemsPerPage && i<this.purchasables.length; i++) {
        if (typeof (this.purchasables[i].name) === 'undefined') {
          backendCall.purchasable.getPurchasableInfo(
              this.storeAccount,
              this.purchasables[i].purchasableId
          ).then((res) => {
            if (res.status === 1) {
              let purchasable = this.purchasables[i]
              purchasable.name = res.data ? res.data.name : ''
              purchasable.description = res.data ? res.data.description : ''
              purchasable.imageUrl = res.data ? res.data.imageUrl : ''
              this.$set(this.purchasables, i, purchasable)
            }
          })
        }
      }
    }
  }
}
</script>